import { Box, VStack } from '@genial/components';
import React from 'react';

import { reportGeneratorTheme } from '../../../../constants/theme';
import { DocumentsTableSkeletonRow } from '../SkeletonRow';

const DOCUMENTS_TABLE_INITIAL_SKELETON_COUNT = 5;

interface DocumentsTableSkeletonListProps {
  count?: number;
  itemSeparatorSpace?: string;
}

export const DocumentsTableSkeletonList: React.FC<DocumentsTableSkeletonListProps> = ({
  count = DOCUMENTS_TABLE_INITIAL_SKELETON_COUNT,
  itemSeparatorSpace = reportGeneratorTheme.table.itemGap,
}) => (
  <VStack space={itemSeparatorSpace} width="full" bg="transparent">
    {Array.from({ length: count }).map((_, index) => (
      <Box key={`documents-table-skeleton-${index}`} bg="transparent">
        <DocumentsTableSkeletonRow />
      </Box>
    ))}
  </VStack>
);
